import { createAction, props } from '@ngrx/store';

// Save token to store
export const saveToken = createAction(
  '[Auth] Save Token',
  props<{ token: string }>()
);

// Remove token (e.g., logout or expiry)
export const removeToken = createAction('[Auth] Remove Token');

// Optionally request token (not required by NgRx but useful in effects)
export const getToken = createAction('[Auth] Get Token');
